/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zns_Otp_Param_MissingInputs */

const vi_error_zns_otp_param_missing = /** @type {(inputs: Error_Zns_Otp_Param_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có tham số nào nhận Mã OTP — map Mã OTP vào một tham số của mẫu.`)
};

/**

* @param {Error_Zns_Otp_Param_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_otp_param_missing = /** @type {((inputs?: Error_Zns_Otp_Param_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Otp_Param_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_otp_param_missing(inputs)
});